import { readNotificationFieldError, NOTIFICATION_ERROR_FIELDS } from '../../../../utils/notificationFormErrors';

function errorReader(keys) {
  return function notificationFieldError() {
    return readNotificationFieldError(this.serverErrors, keys);
  };
}

export default {
  computed: {
    nameError: errorReader(NOTIFICATION_ERROR_FIELDS.NAME),
    locationsError: errorReader(NOTIFICATION_ERROR_FIELDS.LOCATIONS),
    rolesError: errorReader(NOTIFICATION_ERROR_FIELDS.ROLES),
    offsetError: errorReader(NOTIFICATION_ERROR_FIELDS.OFFSET),
    recipientsError: errorReader(NOTIFICATION_ERROR_FIELDS.RECIPIENTS),
    scheduleError: errorReader(NOTIFICATION_ERROR_FIELDS.SCHEDULE),
    subjectError: errorReader(NOTIFICATION_ERROR_FIELDS.SUBJECT),
    bodyError: errorReader(NOTIFICATION_ERROR_FIELDS.BODY),
    categoryError: errorReader(NOTIFICATION_ERROR_FIELDS.CATEGORY),
    slaError: errorReader(NOTIFICATION_ERROR_FIELDS.SLA),
    endDaysError: errorReader(NOTIFICATION_ERROR_FIELDS.END_DAYS),
  },
};
